// extracted by mini-css-extract-plugin
export default {"custTabsWrapper":"navTabs_custTabsWrapper__RLwse","custTabs":"navTabs_custTabs__qIEc4","custTabContent":"navTabs_custTabContent__aqWQp"};